/**
 * Checks and updates filter alternatives with chosen if exist in query parameters.
 * @param  {Array} filters Array of filter alternatives/objects
 * @param  {String} predefinedQuery
 */
import checkQueryParams, { checkPredefinedQueryParams } from '../../utils/queryParams';
import { getMaxValue, getNestedPageKey, getPageType } from './utils';

export const filterParamsToChosenFacets = (filters, predefinedQuery = '') => {
  const hasPredefinedQuery = predefinedQuery && predefinedQuery !== '';
  return [...filters].map((item) => {
    const queryKeyValue = hasPredefinedQuery
      ? checkPredefinedQueryParams(item.key, predefinedQuery)
      : checkQueryParams(item.key);
    const queryKey = item.key;
    const querySubKeyValue = hasPredefinedQuery
      ? checkPredefinedQueryParams(item.key, predefinedQuery)
      : checkQueryParams(item.subKey);

    let activeFilters = 0;

    if (queryKeyValue) {
      const splitQueryValue = queryKeyValue.split(',');
      const splitQuerySubValue = querySubKeyValue?.split(',') || [];

      if (getPageType(queryKey) === 'range') {
        const splitMaxPart = Number(splitQueryValue[1]);
        item.chosenMinValue = Number(splitQueryValue[0]);
        item.chosenMaxValue =
          splitMaxPart === -1 ? getMaxValue(queryKey, item?.maxValue) : splitMaxPart;
      } else {
        item.options = item.options.map((filterItem) => {
          let nestedActiveFilters = 0;

          if (splitQueryValue.indexOf(filterItem.value) !== -1) {
            filterItem.chosen = true;

            if (filterItem.chosen) activeFilters += 1;

            if (item.subKey !== '' && querySubKeyValue) {
              filterItem[getNestedPageKey(Object.keys(filterItem)[0])] = filterItem[
                getNestedPageKey(Object.keys(filterItem)[0])
              ].map((nestedItem) => {
                if (splitQuerySubValue.indexOf(nestedItem.value) !== -1) {
                  nestedItem.chosen = true;
                }

                if (nestedItem.chosen) nestedActiveFilters += 1;

                return { ...nestedItem };
              });
            }
          }

          return { ...filterItem, activeFilters: nestedActiveFilters };
        });
      }
    }

    return { ...item, activeFilters };
  });
};
